/* Данные страницы. Все цифры — фактическая статистика базы 100 Юристов
   за 12 месяцев (авг. 2025 — авг. 2026). Обновлять раз в квартал. */

/* Общий поток заявок в месяц (все тематики, размеченные и нет) */
export const FLOW_PER_MONTH = 16076;

/* Тематики: [название, заявок в месяц по размеченной части базы] */
export const TOPICS = [
    ["Гражданское право", 1129],
    ["Семейное право", 1018],
    ["Трудовое право", 688],
    ["Жилищное право", 662],
    ["Уголовное право", 528],
    ["Защита прав потребителей", 371],
    ["Земельное право", 365],
    ["Автомобильное право", 346],
    ["Исполнительное производство", 299],
    ["Соцобеспечение", 272],
    ["Военное право", 255],
    ["Наследственное право", 242],
    ["Медицинское право", 122],
    ["Миграционное право", 120],
    ["Банкротство", 106],
    ["Административное право", 105],
    ["Налоговое право", 103],
    ["Кредиты", 82],
    ["Общие вопросы", 46],
    ["Корпоративное право", 43],
    ["Образование", 32],
    ["Ипотека", 21],
    ["Авторские и смежные права", 15],
    ["ЖКХ", 10],
    ["Лицензирование", 10],
    ["Таможенное право", 8],
    ["Договорное право", 7],
    ["Арбитраж", 3],
    ["Тендеры и закупки", 1],
    ["Интернет и право", 1],
];

/* Регионы: [название, заявок в месяц, федеральный округ].
   Округ хранится справочно — в интерфейсе не используется:
   закупка идёт только регионами, поиск по списку идёт по названию. */
export const REGIONS = [
    ["Москва и Московская область", 1527, "ЦФО"],
    ["Краснодарский край", 1034, "ЮФО"],
    ["Свердловская область", 640, "УФО"],
    ["Санкт-Петербург и Ленинградская область", 547, "СЗФО"],
    ["Ростовская область", 503, "ЮФО"],
    ["Башкортостан", 502, "ПФО"],
    ["Красноярский край", 497, "СФО"],
    ["Иркутская область", 467, "СФО"],
    ["Кемеровская область", 449, "СФО"],
    ["Челябинская область", 419, "УФО"],
    ["Новосибирская область", 407, "СФО"],
    ["Татарстан", 392, "ПФО"],
    ["Ханты-Мансийский АО — Югра", 352, "УФО"],
    ["Омская область", 350, "СФО"],
    ["Самарская область", 345, "ПФО"],
    ["Ставропольский край", 334, "СКФО"],
    ["Калининградская область", 333, "СЗФО"],
    ["Саратовская область", 320, "ПФО"],
    ["Пермский край", 307, "ПФО"],
    ["Нижегородская область", 296, "ПФО"],
    ["Волгоградская область", 278, "ЮФО"],
    ["Оренбургская область", 261, "ПФО"],
    ["Приморский край", 259, "ДФО"],
    ["Республика Крым", 247, "ЮФО"],
    ["Республика Алтай", 231, "СФО"],
    ["Тюменская область", 207, "УФО"],
    ["Хабаровский край", 195, "ДФО"],
    ["Тульская область", 178, "ЦФО"],
    ["Тверская область", 174, "ЦФО"],
    ["Воронежская область", 172, "ЦФО"],
    ["Владимирская область", 156, "ЦФО"],
    ["Ульяновская область", 151, "ПФО"],
    ["Томская область", 146, "СФО"],
    ["Ярославская область", 140, "ЦФО"],
    ["Рязанская область", 138, "ЦФО"],
    ["Забайкальский край", 137, "ДФО"],
    ["Брянская область", 137, "ЦФО"],
    ["Кировская область", 132, "ПФО"],
    ["Астраханская область", 125, "ЮФО"],
    ["Удмуртская Республика", 122, "ПФО"],
    ["Липецкая область", 118, "ЦФО"],
    ["Вологодская область", 116, "СЗФО"],
    ["Амурская область", 112, "ДФО"],
    ["Калужская область", 110, "ЦФО"],
    ["Якутия", 105, "ДФО"],
    ["Белгородская область", 105, "ЦФО"],
    ["Чувашия", 104, "ПФО"],
    ["Курская область", 102, "ЦФО"],
    ["Бурятия", 93, "ДФО"],
    ["Дагестан", 87, "СКФО"],
    ["Архангельская область", 86, "СЗФО"],
    ["Ямало-Ненецкий АО", 78, "УФО"],
    ["Алтайский край", 78, "СФО"],
    ["Республика Коми", 75, "СЗФО"],
    ["Сахалинская область", 74, "ДФО"],
    ["Тамбовская область", 73, "ЦФО"],
    ["Пензенская область", 71, "ПФО"],
    ["Мурманская область", 66, "СЗФО"],
    ["Курганская область", 65, "УФО"],
    ["Смоленская область", 63, "ЦФО"],
    ["Ивановская область", 55, "ЦФО"],
    ["Республика Карелия", 55, "СЗФО"],
    ["Хакасия", 51, "СФО"],
    ["Марий Эл", 47, "ПФО"],
    ["Орловская область", 44, "ЦФО"],
    ["Республика Мордовия", 42, "ПФО"],
    ["Новгородская область", 41, "СЗФО"],
    ["Костромская область", 40, "ЦФО"],
    ["Северная Осетия", 39, "СКФО"],
    ["Псковская область", 38, "СЗФО"],
    ["Камчатский край", 35, "ДФО"],
    ["Кабардино-Балкария", 28, "СКФО"],
    ["Чеченская Республика", 24, "СКФО"],
    ["Адыгея", 21, "ЮФО"],
    ["Карачаево-Черкесия", 20, "СКФО"],
    ["Тува", 20, "СФО"],
    ["Еврейская АО", 19, "ДФО"],
    ["Магаданская область", 19, "ДФО"],
    ["Калмыкия", 18, "ЮФО"],
    ["Ингушетия", 13, "СКФО"],
    ["Херсонская область", 7, "ЮФО"],
    ["Чукотский АО", 7, "ДФО"],
    ["Запорожская область", 7, "ЮФО"],
];

/* Регионы, в которых есть города-миллионники. Пресет быстрого выбора:
   закупка идёт регионами целиком, отдельный город выбрать нельзя. */
export const MILLION_REGIONS = [
    "Москва и Московская область",
    "Санкт-Петербург и Ленинградская область",
    "Новосибирская область",
    "Свердловская область",
    "Татарстан",
    "Нижегородская область",
    "Челябинская область",
    "Самарская область",
    "Омская область",
    "Ростовская область",
    "Башкортостан",
    "Красноярский край",
    "Пермский край",
    "Воронежская область",
    "Волгоградская область",
    "Краснодарский край",
];

/* Примеры реальных заявок. Тексты подлинные, имена и телефоны скрыты. */
export const LEAD_SAMPLES = [
    { t: "Исполнительное производство", r: "Иркутская область", d: "август 2026", q: "Добрый день. Я в разводе. 16 мая 2023 г. получила судебный приказ на алименты (2 ребёнка). Бывший муж попросил не пускать в дело приказ, платил алименты сам, по договорённости. В последнее время алименты платить перестал. Могу ли я отнести приказ к приставам? Меня смущает, что есть какие-то 3 года, после которых приказ теряет свою силу." },
    { t: "Кредиты", r: "Башкортостан", d: "август 2026", q: "Здравствуйте! Такой вопрос: брала для парня микрозаймы, так как ему отказывали. Сейчас мы расстались, и возвращать долги он отказывается. Общая сумма долгов составляет около 100 тысяч. Он не работает официально, и его счета заблокированы, так как не оплатил вовремя микрозаймы. Возможно ли обратиться в суд для того, чтобы он вернул деньги?" },
    { t: "Гражданское право", r: "Ростовская область", d: "август 2026", q: "Выиграл суд первой инстанции. Ответчик подал жалобу в областной суд, предоставив квитанцию, что посылал мне копию жалобы. Но у меня нет этой жалобы, и подозреваю, что ответчик использовал халатность почты. Времени осталось мало, чтобы истребовать её у суда для ознакомления. Могу ли я написать не отзыв на жалобу, а предоставить объяснения в порядке ст. 35 ГПК?" },
    { t: "Жилищное право", r: "Тульская область", d: "август 2026", q: "Есть общедолевой дом с двумя входами. В одной половине проживаю я и моя семья. Сложившийся порядок пользования: уже более 100 лет моя семья проживает в одной половине и ухаживает за ней. Вторая половина разрушена. Сосед говорит, чтобы её делали вместе, т. к. дом общедолевой. Каждая половина равна долям. Вторая половина не пригодна для проживания." },
    { t: "Банкротство", r: "Свердловская область", d: "август 2026", q: "Как правильно составить обращение в ЦБ РФ об исключении из реестра банковских реквизитов? Реквизиты включены на основании ФЗ-161 ст. 9 п. 11.6. Банк передал реквизиты в ЦБ РФ из-за жалобы на перевод. Данный перевод был возвращён отправителю." },
    { t: "Кредиты", r: "Свердловская область", d: "август 2026", q: "Добрый день! Есть долг на сумму 3,1 млн, который включает в себя кредиты, кредитные карты и микрозаймы, на текущий момент есть просрочки до 20 к. д. только по микрозаймам. Вопрос: есть ли смысл подавать на банкротство при з/п 150 000 р/месяц и какое может вынести решение суд? Как распределяется доход при реструктуризации долга?" },
    { t: "Военное право", r: "Томская область", d: "август 2026", q: "Можно ли, отучившись 11 классов, пойти в колледж по аттестату за 9 класс и сохранить отсрочку от армии? И ещё: если заключил 1 августа целевое с вузом, можно ли будет в конце вуза отменить целевое без последствий и пойти в колледж?" },
    { t: "Наследственное право", r: "Краснодарский край", d: "август 2026", q: "Я хочу расписаться с женщиной, у которой есть взрослые дети. Имею недвижимость, а также являюсь наследником родительского имущества. У моей будущей жены нет ничего. Не хотелось бы в случае непредвиденных обстоятельств потерять часть своего имущества. Подскажите, как мне поступить?" },
    { t: "Трудовое право", r: "Самарская область", d: "август 2026", q: "Здравствуйте, работаю в детском саду музыкальным руководителем на ставку, 4 группы. А моя коллега работала на полставки и уволилась. Мне хотят оформить совместительство на полставки и работать ещё два с лишним часа. Я прошу оформить совмещение на полставки без удлинения рабочего времени. Все занятия у меня укладываются в моё рабочее время. Отказывают. Звонить в трудовую инспекцию?" },
    { t: "Банкротство", r: "Ростовская область", d: "август 2026", q: "Здравствуйте! Муж оформил банкротство, но процесс ещё не завершился. Сначала пытались продать машину (оформленную на меня) на торгах, видно, не получилось, а сейчас с меня требуют предоставить справку 2-НДФЛ о доходах за 2 года. Я сейчас не работаю. Имеют ли право меня принудить выплачивать долги за мужа, если он банкрот?" },
    { t: "Соцобеспечение", r: "Свердловская область", d: "август 2026", q: "Человек сменил место проживания с одного региона на другой и зарегистрировался по новому адресу. Пенсионный фонд оформил выплату пенсии по новому месту жительства. В какое ведомство следует обратиться для оформления положенных пенсионеру льгот, таких как проезд в общественном транспорте и другие?" },
    { t: "Административное право", r: "Красноярский край", d: "август 2026", q: "Добрый вечер, хотелось бы узнать: поругались с женой, мать её поняла не так, вызвала полицию. Полиция приехала, заявление не писали, потому что ничего не было, и объяснили, что просто поругались, взяли объяснения с жены. Придёт ли ПДН, если есть ребёнок меньше года?" },
    { t: "Наследственное право", r: "Томская область", d: "август 2026", q: "Вступили с братом в наследство, у нас по 1/2 доли в квартире. Но при жизни мама прописала внука, он до сих пор там прописан. В квартире не проживал, за квартиру не платил, но после смерти мамы проживает в квартире с женой и ребёнком (жена и ребёнок не прописаны). Можно ли выписать внука, чтобы продать квартиру?" },
    { t: "Гражданское право", r: "Тюменская область", d: "август 2026", q: "Здравствуйте, подскажите, пожалуйста: судебный приказ вступил в силу 18.07.26, на руки получила в суде у секретаря 30.07.26. Десятидневный срок получается пропущен? Отменят ли судебный приказ, если приложить ходатайство о восстановлении срока?" },
];
